<div class="desktop-container" [ngClass]="{'last': isLast}">
    <div>
        <span class="intro">
            @if (audit; as audit) {
                <div>
                    <h3 class="p-0 m-0">{{ getTitle() }}</h3>
                    <div class="flex items-center gap-2">
                        <p>Due Date <b>{{ dateUtils.formatDateWithConditionalYear(getDueDate()) }}.</b></p>
                        <p>Status: <b>{{ getStatus() }}</b></p>
                    </div>
                </div>
            }
        </span>
    </div>
    <div class="form-type type-audit">
        Internal Audit
    </div>
    <div class="flex justify-content-between flex-nowrap gap-3">
        <div class="flex-1"></div>
        <a
            class="btn-secondary flex-1"
            [routerLink]="['/assurance/internal-audit', audit._id]"
            (click)="$event.stopPropagation()">
            View
        </a>
    </div>
</div>
